import styled from 'styled-components';

export const Headercontent = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 53px;
  background: #fff;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 10;

  & > .logo {
    position: absolute;
    width: 150px;
    height: 70px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    top: 28px;
    @media screen and (orientation: portrait) {
      width: 100px;
      height: 60px;
      top: 7px;
    }
  }

  & > .menuIcon {
    position: absolute;
    top: auto;
    left: 20px;
    cursor: pointer;
    display: none;
    @media screen and (orientation: portrait) {
      display: flex;
    }
  }

  & > .atSign {
    position: absolute;
    top: auto;
    right: 20px;
    cursor: pointer;
  }

  & > .backButton {
    position: absolute;
    left: 20px;
    top: auto;
    cursor: pointer;
  }

  & .logoBlogDesk {
    display: flex;
    @media screen and (orientation: portrait) {
      display: none;
    }
  }

  & .logoBlogMob {
    display: none;
    @media screen and (orientation: portrait) {
      display: flex;
    }
  }
  & > .about {
    position: relative;
    left: 75px;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 1px;
    color: #000;
    cursor: pointer;
    margin-right: 20px;
    @media screen and (orientation: portrait) {
      display: none;
    }
  }
  & > .telf {
    position: absolute;
    top: auto;
    right: 75px;
    font-size: 16px;
    font-weight: 400;
    color: #000;
    text-decoration: underline;
    cursor: pointer;
    @media screen and (orientation: portrait) {
      right: 20px;
    }
  }
  @media screen and (orientation: portrait) {
    justify-content: center;
  }
`;

export const ModalMenuBlog = styled.div` 
  position: fixed;
  left: 0;
  top: 60px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  z-index: 100;
  border-bottom: 1px solid #ddd;
`;

export const NoHeadeMenu = styled.div`
  display: none;
  & > .menuIconNoheader {
    position: absolute;
    top: 38px;
    left: 35px;
    z-index: 1;
  }
  @media screen and (orientation: portrait) {
    display: flex;
  }
`;
 